import { render, staticRenderFns } from "./smsTemplate.vue?vue&type=template&id=3b9c6113"
import script from "./smsTemplate.vue?vue&type=script&lang=js"
export * from "./smsTemplate.vue?vue&type=script&lang=js"
import style0 from "./smsTemplate.vue?vue&type=style&index=0&id=3b9c6113&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports